export const environment = {
    baseUrl: ''
};
